export const THEMES = {
  "midnight-gold": { "--bg": "#0d0f1a", "--bg-warm": "#151829", "--ink": "#f5ecd7", "--muted": "#a9a6b8", "--gold": "#d9b45a", "--line": "#2a2e45", color: "#f5ecd7" },
  "blush-champagne": { "--bg": "#fff8f5", "--bg-warm": "#f9e8e2", "--ink": "#3d2a2a", "--muted": "#8a6f6c", "--gold": "#c99a7c", "--line": "#efd9d1" },
  "emerald-estate": { "--bg": "#f4f6f2", "--bg-warm": "#e3eadf", "--ink": "#13291f", "--muted": "#5b6e62", "--gold": "#b08d3c", "--line": "#d3ddd0" },
  "noir-editorial": { "--bg": "#ffffff", "--bg-warm": "#f2f2f2", "--ink": "#000000", "--muted": "#5c5c5c", "--gold": "#111111", "--line": "#e0e0e0" },
};

export const themeStyle = (id) => THEMES[id] || undefined;
